import './customCheckbox.css'

interface CheckboxProps {
    label: string,
    checked: boolean,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    name: string,
    id: string,
    disabled?: boolean
}

const CustomCheckbox = ({ label, checked, onChange, name, id, disabled = false, ...rest }: CheckboxProps) => {
    return (
        <label
            htmlFor={id.toString()}
            className={`checkbox-custom-wrapper min-w-0 ${!disabled ? 'cursor-pointer' : 'cursor-not-allowed'}`}
        >
            <span className='label-checkbox-custom shrink-0'>
                <input
                    type="checkbox"
                    id={id.toString()}
                    name={name}
                    checked={checked}
                    onChange={onChange}
                    {...rest}
                    className={checked ? 'checked-custom' : ''}
                    disabled={disabled}
                />
                <span className='span-custom-checkbox'></span>
            </span>
            {
                label && label.length > 0 &&
                <span
                    className={`truncate min-w-0 flex-1 text-system-light-100 text-bmedium pl-3 ${disabled ? 'opacity-50' : ''}`}
                    title={label}
                >{label}</span>
            }
        </label>
    );
};

export default CustomCheckbox;